import { render, staticRenderFns } from "./Bottom.vue?vue&type=template&id=62de33c2&scoped=true&"
import script from "./Bottom.vue?vue&type=script&lang=js&"
export * from "./Bottom.vue?vue&type=script&lang=js&"
import style0 from "./Bottom.vue?vue&type=style&index=0&id=62de33c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62de33c2",
  null
  
)

export default component.exports